module.exports = __webpack_public_path__ + "img/home-banner-img.8d5d3806.png";